<template>
  <div class="text-body-1">
    <slot name="label" :label="label" :value="value">
      <div>{{ label }}</div>
    </slot>
    <slot name="value" :label="label" :value="value">
      <div class="ml-3">
        {{ value }}
      </div>
    </slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "vue";

/**
 * 参照画面や確認画面の各アイテムの表示用Wrapper
 */
export default defineComponent({
  name: "AppLabelGroup",
  inheritAttrs: true,
  props: {
    // 項目名
    label: {
      type: String as PropType<string>,
      required: false,
    },
    // 項目値
    value: {
      type: [String, Number] as PropType<string | number | unknown>,
      required: false,
    },
  },
});
</script>

<style lang="scss" scoped></style>
